import { createContext, useContext, useState } from "react";

const InfoContext = createContext();

export const InfoProvider = ({ children }) => {
  const [infoEnabled, setInfoEnabled] = useState(false);

  return (
    <InfoContext.Provider value={{ infoEnabled, setInfoEnabled }}>
      {children}
    </InfoContext.Provider>
  );
};

export const useInfo = () => useContext(InfoContext);